export function modbusDeviceShareViewerSearch(search: string): boolean {
  const q = new URLSearchParams(search);
  const fs = String(q.get("from_share") || "").trim().toLowerCase();
  if (!["1", "true", "yes", "on"].includes(fs)) return false;
  return Boolean(String(q.get("id") || "").trim());
}
/** Third-party embed: ``/modbus-device-view/machine?id=&view_token=`` (1h device-view token; no session). */
